import { render } from "./VenueMapCanvas.vue?vue&type=template&id=148e511c&scoped=true"
import script from "./VenueMapCanvas.vue?vue&type=script&lang=js"
export * from "./VenueMapCanvas.vue?vue&type=script&lang=js"

import "./VenueMapCanvas.vue?vue&type=style&index=0&id=148e511c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148e511c"]])

export default __exports__